/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Edit_NeverInputs */

const en_us2_plan_edit_never = /** @type {(inputs: Plan_Edit_NeverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Don't recommend again`)
};

const pt_br2_plan_edit_never = /** @type {(inputs: Plan_Edit_NeverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não recomendar mais`)
};

const es_419_plan_edit_never = /** @type {(inputs: Plan_Edit_NeverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No recomendar más`)
};

const pt_pt2_plan_edit_never = /** @type {(inputs: Plan_Edit_NeverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não recomendar mais`)
};

const fr_fr2_plan_edit_never = /** @type {(inputs: Plan_Edit_NeverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ne plus recommander`)
};

const de_de2_plan_edit_never = /** @type {(inputs: Plan_Edit_NeverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nicht mehr empfehlen`)
};

const it_it2_plan_edit_never = /** @type {(inputs: Plan_Edit_NeverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non consigliare più`)
};

/**
* | output |
* | --- |
* | "Don't recommend again" |
*
* @param {Plan_Edit_NeverInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_edit_never = /** @type {((inputs?: Plan_Edit_NeverInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Edit_NeverInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_edit_never(inputs)
	if (locale === "es-419") return es_419_plan_edit_never(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_edit_never(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_edit_never(inputs)
	if (locale === "de-DE") return de_de2_plan_edit_never(inputs)
	if (locale === "it-IT") return it_it2_plan_edit_never(inputs)
	return en_us2_plan_edit_never(inputs)
});
export { plan_edit_never as "plan-edit.never" }